<!-- <svelte:options customElement="clever-search-rating" /> -->

<script lang="ts">
  import { state_answerRating } from '../../../store/state';

  import { _ } from 'svelte-i18n';

  export let updateTimer: any;
  export let updateSuccess: boolean;
  export let updateFail: boolean;

  export let isUpdating: boolean;
  export let sendRating: any;
</script>

<!-- default loading is thumbs view-->

<button
  class="cs-thumb"
  class:busy={isUpdating}
  class:active={$state_answerRating?.score == 1}
  aria-label={$_('rating.thumbs_up')}
  title={$_('rating.thumbs_up')}
  on:keypress={() => sendRating(1)}
  on:click={() => sendRating(1)}
>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1111_5998)">
      <path
        d="M6.48899 10.0199L11.4885 2.294C11.9272 1.66947 12.6427 1.29776 13.4059 1.29776C14.8293 1.29776 15.9239 2.55621 15.7268 3.96581L15.3176 6.89061H18.4678C20.0324 6.89061 23.1617 8.45524 23.1617 11.5845C23.1617 14.7138 20.4439 21.8712 17.1156 21.8712C13.2167 21.8712 9.28675 20.7056 7.18236 20.0815C6.92215 20.0044 6.68986 19.9354 6.48899 19.878H5.16003V10.0199H6.48899Z"
        stroke="currentColor"
        stroke-width="1.71446"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.15998 20.5854V9.71573C5.15998 8.53214 4.2005 7.57266 3.01691 7.57266C1.83332 7.57266 0.87384 8.53214 0.87384 9.71573V20.5854C0.87384 21.769 1.83332 22.7285 3.01691 22.7285C4.2005 22.7285 5.15998 21.769 5.15998 20.5854Z"
        stroke="currentColor"
        stroke-width="1.71446"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1111_5998">
        <rect
          width="24.0024"
          height="24.0024"
          fill="white"
          transform="translate(0.0166626 0.0119324)"
        />
      </clipPath>
    </defs>
  </svg>
</button>
<button
  class="cs-thumb busy down"
  class:busy={isUpdating}
  class:active={$state_answerRating?.score == 0}
  aria-label={$_('rating.thumbs_down')}
  title={$_('rating.thumbs_down')}
  on:keypress={() => sendRating(0)}
  on:click={() => sendRating(0)}
>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_3)">
      <path
        d="M17.5277 13.9921L12.5282 21.7179C12.0894 22.3425 11.374 22.7142 10.6107 22.7142C9.1874 22.7142 8.09274 21.4557 8.2899 20.0461L8.69903 17.1213H5.54885C3.98424 17.1213 0.855011 15.5567 0.855011 12.4274C0.855011 9.29818 3.57277 2.1407 6.90109 2.1407C10.8 2.1407 14.7299 3.30636 16.8343 3.93042C17.0945 4.00757 17.3268 4.07649 17.5277 4.13393H18.8566V13.9921H17.5277Z"
        stroke="black"
        stroke-width="1.71446"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8567 3.42655V14.2962C18.8567 15.4798 19.8161 16.4393 20.9997 16.4393C22.1833 16.4393 23.1428 15.4798 23.1428 14.2962V3.42655C23.1428 2.24289 22.1833 1.28348 20.9997 1.28348C19.8161 1.28348 18.8567 2.24289 18.8567 3.42655Z"
        stroke="black"
        stroke-width="1.71446"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3">
        <rect
          width="24.0024"
          height="24.0024"
          fill="white"
          transform="matrix(-1 0 0 -1 24 24)"
        />
      </clipPath>
    </defs>
  </svg>
</button>

<style lang="scss">
  @use './../../../../scss/components/themes/rating-theme/rating-theme';
</style>
